import { Injectable, signal } from '@angular/core';

/**
 * Pano shell ↔ child routes arası paylaşılan kart/kişi state servisi.
 * Pano (shell) kart okuyucu event'lerinden günceller, child route'lar okur.
 * Navigasyon pano shell tarafından router ile yapılır.
 */
@Injectable({ providedIn: 'root' })
export class PanoDurumService {
  // ─── Tanınan kişi ────────────────────────────────────────────────────────
  readonly taninanKisi = signal<{
    isim: string; soyIsim: string; rol: string;
    resimUrl: string; girisSaati: string;
  }>({ isim: '', soyIsim: '', rol: '', resimUrl: '', girisSaati: '' });

  readonly kisiYetkileri = signal<string[]>([]);
  readonly sonPersonel = signal<any>(null);
  readonly sonGirisler = signal<{ isim: string; soyisim: string; rol: string; saat: string; resimUrl: string }[]>([]);

  // ─── Helpers ─────────────────────────────────────────────────────────────
  get karanlikMod(): boolean { return document.body.classList.contains('hmi-karanlik'); }

  get superYoneticiMi(): boolean {
    return this.kisiYetkileri().some(y => {
      const yetki = String(y || '').toLocaleLowerCase('tr-TR');
      return yetki === 'hmi.puantaj_duzenle'
        || yetki === 'puantaj.duzenle'
        || yetki.includes('süper yönetici')
        || yetki.includes('super yonetici');
    });
  }

  sifirla() {
    this.sonPersonel.set(null);
    this.kisiYetkileri.set([]);
    this.taninanKisi.set({ isim: '', soyIsim: '', rol: '', resimUrl: '', girisSaati: '' });
  }
}
